import { render, staticRenderFns } from "./ImagenesBaseDialog.vue?vue&type=template&id=bc4783d6&scoped=true"
import script from "./ImagenesBaseDialog.vue?vue&type=script&lang=js"
export * from "./ImagenesBaseDialog.vue?vue&type=script&lang=js"
import style0 from "./ImagenesBaseDialog.vue?vue&type=style&index=0&id=bc4783d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4783d6",
  null
  
)

export default component.exports